import { render, staticRenderFns } from "./ImportNewFrProject.vue?vue&type=template&id=5a7bfca9"
import script from "./ImportNewFrProject.vue?vue&type=script&lang=js"
export * from "./ImportNewFrProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports